import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import './solicitudes.css'
import Swal from 'sweetalert2'
export default function ModalSolicitud({ solicitud, setIsOpen }) {
    function useEscKey(onEsc) {
        useEffect(() => {
            const handleKeyDown = (event) => {
                if (event.key === 'Escape') {
                    onEsc();
                }
            };
            window.addEventListener('keydown', handleKeyDown);
            return () => {
                window.removeEventListener('keydown', handleKeyDown);
            };
        }, [onEsc]);
    }
    useEscKey(() => {
        setIsOpen(false)
    });
    const [nro, setNro] = useState('')
    const [observacionAl3ro, setObservacionAl3ro] = useState('')
    const existeCoincidencia = solicitud?.coincidencias?.find(c => {
        const nroStr = c?.nroStro != null ? c.nroStro.toString() : '';
        return nroStr.substring(3) === nro.toString();
    });
    // redireccionar nroStro
    const handleClick = async (nroStro) => {
        if (!nroStro) return; // Si no hay nroStro, no seguimos.
        try {
            const response = await axios.get(`https://reclamosback.agsseguros.online/apiReclamos/empleadosSolicitudes/obtener-id/${nroStro}`);
            const data = response.data;
            if (data?.id) {
                window.open(`/#/${data.id}`, '_blank');
            } else {
                console.error('No se encontró el ID.');
            }
        } catch (error) {
            console.error('Error buscando el ID:', error);
        }
    };
    //
    const aprobarSolicitud = useCallback(async (e) => {
        /* e.preventDefault();
         Swal.fire({
             title: 'Procesando...',
             text: 'Aprobando solicitud',
             allowOutsideClick: false,
             didOpen: () => {
                 Swal.showLoading();
             }
         });
         try {
             const response = await axios.post(`http://localhost:8080/apiReclamos/empleadosSolicitudes/aprobarSolicitud`,
                 {
                     idReclamo: solicitud.id,
                     nroStro: nro
                 }
             );
             if (response) {
                 Swal.fire({
                     icon: 'success',
                     title: 'Solicitud aprobada',
                     showConfirmButton: false,
                     timer: 1500
                 }).then(() => {
                     window.location.reload();
                 });
             }
         } catch (error) {
             Swal.fire({
                 icon: 'error',
                 title: 'Error',
                 text: 'No se pudo aprobar la solicitud. Intenta nuevamente.',
             });
             console.error(error);
         }*/
    }, [solicitud, nro]);
    return (
        <>
            <div className="modalOpenSolicitud" >
                <h3 className="tituloModal d-flex justify-content-center align-items-center position-relative">
                    POSIBLES SINIESTROS VINCULADOS
                    <button className="btn btn-link position-absolute end-0" onClick={() => setIsOpen(false)}>
                        <i className="bi bi-x-lg" style={{ color: 'black', fontSize: '20px' }}></i>
                    </button>
                </h3>
                <h4 className="center subtituloModal">EL SISTEMA INTENTARÁ ENCONTRAR UNA COINCIDENCIA CON ALGÚN<br /> SINIESTRO CARGADO, EN CASO DE NO ENCONTRAR, SOLICITAR<br /> RECTIFICACIÓN O CARGAR MANUALMENTE</h4>
                <h5 className="textoModalSolicitud">DATOS CARGADOS POR 3RO</h5>
                <div className="d-flex gap-2">
                    <div className="burbujaTextoModal textoModalSolicitud"><strong style={{ fontWeight: 'bold' }}>TIPO 3RO:</strong>&nbsp;{solicitud.tipoReclamante}</div>
                    <div className="burbujaTextoModal textoModalSolicitud"><strong style={{ fontWeight: 'bold' }}>DOM ASEG: </strong>&nbsp;{solicitud.patenteAseg}</div>
                    <div className="burbujaTextoModal textoModalSolicitud"><strong style={{ fontWeight: 'bold' }}>DOM 3RO: </strong>&nbsp;{solicitud.patenteRec}</div>
                    <div className="burbujaTextoModal textoModalSolicitud"><strong style={{ fontWeight: 'bold' }}>FECH STRO: </strong>&nbsp;{new Date(solicitud.fechaStroRec).toLocaleDateString()}</div>
                </div>
                <div className="burbujaTextareaModal textoModalSolicitud" style={{ marginTop: '12px' }}><strong style={{ fontWeight: 'bold' }}>OBSERVACION DEL TERCERO:</strong>&nbsp;{solicitud.obsReclamante}</div>
                <h5 className="textoModalSolicitud" style={{ marginTop: '20px' }}>DATOS ASEGURADO</h5>
                <div className="d-flex gap-2">
                    <input type="text" className="burbujaTextoModal textoModalSolicitud" style={nro && existeCoincidencia ? { border: '3px solid #579CDF' } : {}} placeholder="NRO STRO" value={nro} onChange={(e) => setNro(e.target.value)} />

                    <div className="burbujaTextoModal textoModalSolicitud" style={existeCoincidencia && nro ? existeCoincidencia.dom === solicitud.patenteAseg ? { border: '3px solid #579CDF' } : { border: '3px solid red' } : undefined}><stong style={{ fontWeight: 'bold' }}>DOM ASEG:</stong>&nbsp;{existeCoincidencia?.dom}</div>

                    <div className="burbujaTextoModal textoModalSolicitud" style={existeCoincidencia && nro ? existeCoincidencia.dominioTercero1 === solicitud.patenteRec ? { border: '3px solid #579CDF' } : { border: '3px solid red' } : undefined}><strong style={{ fontWeight: 'bold' }}>DOM 3RO:</strong>&nbsp;{existeCoincidencia?.dominioTercero1}</div>

                    <div className="burbujaTextoModal textoModalSolicitud" style={existeCoincidencia && nro ? new Date(existeCoincidencia.fechaStro).toLocaleDateString() === new Date(solicitud.fechaStroRec).toLocaleDateString() ? { border: '3px solid #579CDF' } : { border: '3px solid red' } : undefined}><strong style={{ fontWeight: 'bold' }}>FECH STRO:</strong>&nbsp;{existeCoincidencia?.fechaStro &&
                        new Date(existeCoincidencia?.fechaStro).toLocaleDateString()}</div>
                </div>
                <div className="tablaCoincidenciasModalSolicitud textoModalSolicitud" style={{ display: 'flex', flexDirection: 'column' }}>
                    <div className="d-flex gap-3" style={{ paddingTop: '13px' }}>
                        <span className="w-100">NRO STRO</span>
                        <span className="w-100">FECHA STRO</span>
                        <span className="w-100">PATENTE</span>
                        <span className="w-100">PATENTE 3RO</span>
                    </div>
                    <div style={{ overflowY: 'auto', flex: 1 }}>
                        {[...solicitud.coincidencias]
                            .map(c => {
                                const coincidencias = (c.fechaStro === solicitud.fechaStroRec ? 1 : 0) + (c.dom === solicitud.patenteAseg ? 1 : 0) + (c.dominioTercero1 === solicitud.patenteRec ? 1 : 0);
                                return { ...c, coincidencias };
                            })
                            .sort((a, b) => b.coincidencias - a.coincidencias)
                            .map((c, index) => (
                                <div key={index} className="tablaCoincidenciasModalSolicitudBody d-flex gap-3 align-items-center py-2 border-bottom">
                                    <span className="w-100" onClick={() => handleClick(c.nroStro.toString().substring(3))} style={{ cursor: c.nroStro ? 'pointer' : 'default', color: c.nroStro ? 'blue' : 'inherit' }}>{c.nroStro != null ? c.nroStro.toString().substring(3) : ''}</span>
                                    <span className="w-100" style={c.fechaStro === solicitud.fechaStroRec ? { background: '#A5FFE0' } : {}}>{new Date(c.fechaStro).toLocaleDateString()}</span>
                                    <span className="w-100" style={c.dom === solicitud.patenteAseg ? { background: '#A5FFE0' } : {}}>{c.dom}</span>
                                    <span className="w-100" style={c.dominioTercero1 === solicitud.patenteRec ? { background: '#A5FFE0' } : {}}>{c.dominioTercero1}</span>
                                </div>
                            ))}
                    </div>
                </div>
                <textarea name="" id="" className="observacionesParaHacerModalSolicitud textoModalSolicitud" placeholder="OBSERVACIONES PARA REALIZAR AL 3RO" value={observacionAl3ro}
                    onChange={(e) => setObservacionAl3ro(e.target.value)}></textarea>
                <div className="d-flex gap-5 center" style={{ marginTop: '10px' }}>
                    <button className="btnSolicitarRecModalSolicitud" disabled={!observacionAl3ro}>SOLICITAR RECT</button>
                    <button className="btnRechazarModalSolicitud" disabled={!observacionAl3ro}>RECHAZAR SOLICITUD</button>
                    <button className="btnAprobarModalSolicitud" disabled={!existeCoincidencia} onClick={(e) => aprobarSolicitud(e)}>APROBAR SOLICITUD</button>
                </div>
            </div>
        </>
    );
}
